import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

const commonInitConfiguration = {
  applicationId: process.env.NEXT_PUBLIC_DD_RUM_APPLICATION_ID ?? '',
  clientToken: process.env.NEXT_PUBLIC_DD_RUM_CLIENT_TOKEN ?? '',
  site: 'datadoghq.com',
  service: process.env.NEXT_PUBLIC_DD_SERVICE,
  env: process.env.NEXT_PUBLIC_DD_ENV,
  version: process.env.NEXT_PUBLIC_DD_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 0,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input'
}

export function initDatadogRum() {
  datadogRum.init({
    ...commonInitConfiguration,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  })

  datadogRum.startSessionReplayRecording()
}

export function initDatadogLogs() {
  datadogLogs.init({
    ...commonInitConfiguration,
    forwardErrorsToLogs: false,
    telemetrySampleRate: 0
  })
}
